import React from 'react';

const WhoHero = ({ title, text, imgData }) => {
    return (
        <section className="relative w-full h-[500px] lg:h-[630px] flex items-center bg-[#000814] overflow-hidden py-12 md:py-0">
            {/* Background Image & Gradient Overlays */}
            <div className="absolute inset-0 z-0">
                <img
                    src={imgData}
                    alt="Abstract 3D Background"
                    className="w-full h-full object-cover"
                />
                {/* Responsive Gradient: Mobile par niche se upar, Desktop par left se right */}
                <div 
                    style={{ background: "linear-gradient(86.84deg, #000000 20%, rgba(0, 0, 0, 0) 79%)" }} 
                    className="hidden md:block absolute inset-0"
                ></div>
                <div 
                    style={{ background: "linear-gradient(0deg, #000000 40%, rgba(0, 0, 0, 0.3) 100%)" }} 
                    className="block md:hidden absolute inset-0"
                ></div>
            </div>

            {/* Content Container */}
            <div className="relative z-10 w-full max-w-[1440px] mx-auto px-[20px] md:px-[40px] lg:px-[80px] flex flex-col items-start justify-center h-full">
                <div className="w-full max-w-[500px] md:max-w-[700px] lg:max-w-[800px] mt-auto md:mt-0">
                    <h1 className="text-white font-[600] text-[28px] sm:text-[36px] md:text-[50px] lg:text-[60px] font-sora leading-[1.2] lg:leading-[1.1] mb-[12px] lg:mb-[22px] drop-shadow-xl tracking-wide text-left">
                        {title}
                    </h1>
                    <p className="text-[#FFFFFF] max-w-[470px] w-full text-[14px] md:text-[16px] leading-[20px] md:leading-[22px] lg:leading-[24px] font-graphik font-light tracking-wider text-left opacity-90 lg:opacity-100">
                        {text}
                    </p>
                </div>
            </div>
        </section>
    );
};

export default WhoHero;